import { Trans } from '@lingui/macro';
import * as React from 'react';

export const inputBooleanIsTrueErrorMessage = (
  <Trans>
    Ce champ doit être coché
  </Trans>
);
